// for reference: packages/nextjs-fullstack-application/node_modules/@deck.gl/layers/src/scatterplot-layer
import { ScatterplotLayer, ScatterplotLayerProps } from "@deck.gl/layers"
import type { DefaultProps } from "@deck.gl/core"
import { AnyAction } from "@nova/constants"

type HotspotPointsLayerDataType = AnyAction

type _HotspotPointsLayerProps = {
    getFilterValue: () => number
    filterRange?: [number, number]
}

type HotspotPointsLayerProps<DataType = HotspotPointsLayerDataType> =
    ScatterplotLayerProps<DataType> & _HotspotPointsLayerProps

const defaultProps: DefaultProps<HotspotPointsLayerProps> = {
    filled: true,
    stroked: true,
    pickable: true,
    // radiusMinPixels: 1,
    // radiusMaxPixels: 6,
    lineWidthUnits: "pixels",
    radiusUnits: "pixels",
    billboard: false,
}

export default class HotspotPointsLayer<
    DataType = HotspotPointsLayerDataType,
    ExtraPropsType extends object = HotspotPointsLayerProps,
> extends ScatterplotLayer<DataType, ExtraPropsType> {
    static defaultProps = defaultProps
    static layerName = "HotspotPoints"
}
